import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
//import { SolicitudExViewModel } from '../datosbasicos/datosbasicosEx.types';

import { AsyncInfoResponseViewModel } from '../../../core/components/asyncInfo/asyncInfo.types';
import { FilterSearchingSolicitudExViewModel } from '../../buscadores/solicitudes/buscador-solicitudEx.types';
import { SolicitudEnvioExViewModel, AuxEnvioExViewModel, EPhytoSubmitPostRequest } from './envioEx.types';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class EnvioExService {
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getLongTimeOutHeaders(): HttpHeaders {
        return new HttpHeaders({ timeout: `${300000}` });
    }

    validarSolicitud(id: number): Observable<string[]> {
        return this.http.get<string[]>(this.baseUrl + 'api/exportacion/envioEx/' + id).pipe();
    }

    //envioSolicitud(solicitud: SolicitudExViewModel): Observable<SolicitudExViewModel> {
    //    return this.http
    //        .put<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/envioEx', solicitud).pipe();
    //}
    envioSolicitud(id: number): Observable<SolicitudEnvioExViewModel> {
        return this.http.put<SolicitudEnvioExViewModel>(this.baseUrl + 'api/exportacion/envioEx', id).pipe();
    }

    getEnvioSolicitud(id: number): Observable<SolicitudEnvioExViewModel> {
        return this.http.get<SolicitudEnvioExViewModel>(this.baseUrl + 'api/exportacion/envioex/getenviosolicitudbyid/' + id).pipe();
    }

    //sendEphytoOnDemand(id: number): Observable<AsyncInfoResponseViewModel> {

    //    return this.http
    //        .get<any>(
    //            this.baseUrl + 'api/exportacion/envioEx/SubmitEphyto/' + id,
    //            {
    //                headers: this.getLongTimeOutHeaders()
    //            }).pipe();
    //}
    sendEphytoOnDemand(ePhytoSubmitPostRequest: EPhytoSubmitPostRequest): Observable<AsyncInfoResponseViewModel> {
        return this.http.post<any>(this.baseUrl + 'api/exportacion/envioEx/SubmitEphyto', ePhytoSubmitPostRequest);
    }

    cancelEphytoOnDemand(id: number): Observable<AsyncInfoResponseViewModel> {
        return this.http
            .get<any>(this.baseUrl + 'api/exportacion/envioEx/CancelEphyto/' + id, {
                headers: this.getLongTimeOutHeaders(),
            })
            .pipe();
    }

    cancelReplaceEphytoOnDemand(id: number): Observable<AsyncInfoResponseViewModel> {
        return this.http
            .get<any>(this.baseUrl + 'api/exportacion/envioEx/CancelReplaceEphyto/' + id, {
                headers: this.getLongTimeOutHeaders(),
            })
            .pipe();
    }

    comprobarEstadosEphytos(model: FilterSearchingSolicitudExViewModel): Observable<any> {
        return this.http.post<FilterSearchingSolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/comprobarEstadosEphytos', model).pipe();
    }

    canSubmit(id: number): Observable<boolean> {
        return this.http.get<any>(this.baseUrl + 'api/exportacion/envioEx/canSubmit/' + id).pipe();
    }

    exportCertificadoFitosanitario(auxEnvioEx: AuxEnvioExViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/exportacion/envioEx/PostExportPdfCertificadoFitosanitario', auxEnvioEx, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    getCertificadoFitosanitario(idSolicitud: number): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/exportacion/envioEx/GetPdfCertificadoFitosanitario', idSolicitud, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    //exportInformeEPhytoTraces(numeroCertificado: string): Observable<HttpResponse<Blob>> {

    //    let request = new GenericPostRequest();

    //    request.Value = numeroCertificado;

    //    return this.http.post(this.baseUrl + 'api/exportacion/envioEx/PostExportEphytoPdfTraces', request, { observe: 'response', responseType: 'blob' })
    //        .pipe();
    //}

    anularCertificadoFitoEx(auxEnvioEx: AuxEnvioExViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/exportacion/envioEx/anularCertificadoFitoEx', auxEnvioEx, { observe: 'response', responseType: 'blob' })
            .pipe();
    }
}
